import { makeStyles } from "@material-ui/core/styles";

export const multipleChoicesStyles = makeStyles(() => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
  },
  subtitle: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#0F172A",
  },
}));
